import { useI18n } from "../contexts/I18nContext";
import {
  isPageTranslated,
  buildLanguageUrl,
  SupportedLanguage,
} from "../config/i18n";

// Helper function to build language-aware URLs
export const useLanguageAwareUrl = () => {
  const { currentLanguage } = useI18n();

  const buildUrl = (path: string): string => {
    // If we're in a non-default language and this page has translations, use language prefix
    if (
      currentLanguage !== "en" &&
      isPageTranslated(path, currentLanguage as SupportedLanguage)
    ) {
      return buildLanguageUrl(path, currentLanguage as SupportedLanguage);
    }

    // For English or untranslated pages, return the original path
    return path;
  };

  return { buildUrl };
};
